import React from 'react';
import { BookOpenIcon, GuitarIcon, CheckIcon } from 'lucide-react';
import { Eyebrow } from './Eyebrow';
const theory = ['Budowa akordów i rodziny akordów septymowych', 'Skale, skale modalne i gdzie każda pasuje', 'Harmonia ii-V-I i popularne substytucje', 'Forma utworu i analiza standardu'];
const practice = ['50 gotowych ćwiczeń jazzowych', 'Ćwiczenia compingu i wzorce rytmiczne', 'Linie, licki i etiudy frazowania', 'Rutyny ćwiczeń krok po kroku według poziomu'];
export function TheoryPractice() {
  return <section aria-labelledby="theory-practice-heading" className="bg-night-900 py-16 sm:py-24" data-id="element-338" data-mp="2hd4fb0a1xciw">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-339" data-mp="2ckbbcemeq87v">
        <div className="mx-auto max-w-3xl text-center" data-id="element-340" data-mp="28ksrzna8i575">
          <Eyebrow align="center" data-id="element-341" data-mp="28k0xkfsdidig">Co otrzymujesz</Eyebrow>
          <h2 id="theory-practice-heading" className="mt-4 font-display text-4xl leading-[0.98] text-cream sm:text-6xl" data-id="element-342" data-mp="352fck7s70osa">
            Teoria <span className="text-amber" data-id="element-343" data-mp="e57ng8lid1y7">+</span> praktyka,{' '}
            <span className="text-amber" data-id="element-344" data-mp="e5ppxmyrkcek">w jednym pakiecie</span>
          </h2>
          <p className="mt-5 font-serif text-lg italic leading-relaxed text-cream-soft" data-id="element-345" data-mp="j39991abjfdd">
            Nie dostajesz samych kart pracy. Dostajesz teorię, by wyjaśnić każde zagadnienie, i 50
            gotowych ćwiczeń jazzowych, które od razu trafią do rąk Twoich uczniów.
          </p>
        </div>
        <div className="mt-10 grid gap-5 sm:mt-12 lg:grid-cols-2 lg:gap-6" data-id="element-346" data-mp="3rj2q5h8kasuy">
          <div className="rounded-2xl border border-night-600 bg-night-800 p-6 sm:p-8" data-id="element-347" data-mp="ecdesz9wet1">
            <div className="flex items-center gap-4" data-id="element-348" data-mp="3hm6ckx3t3gjj">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-wine" data-id="element-349" data-mp="3hnr7inu191hx">
                <BookOpenIcon className="h-6 w-6 text-cream" aria-hidden="true" data-id="element-350" data-mp="3ml9faawbdaoc" />
              </span>
              <div data-id="element-351" data-mp="1fsgtm5z7bifp">
                <p className="text-[11px] font-semibold uppercase tracking-label text-wine-light" data-id="element-352" data-mp="1kto081plybks">
                  Część pierwsza
                </p>
                <h3 className="font-display text-3xl leading-none text-cream" data-id="element-353" data-mp="1jda7f6xk90fq">Teoria</h3>
              </div>
            </div>
            <ul className="mt-7 space-y-4" data-id="element-354" data-mp="1efh2sibwoehk">
              {theory.map(item => <li key={item} className="flex items-start gap-3" data-id="element-355" data-mp="19etbdvjrlvmt">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-wine-light" aria-hidden="true" data-id="element-356" data-mp="15dhnbugjhigq" />
                  <span className="text-sm leading-relaxed text-cream-soft sm:text-base" data-id="element-357" data-mp="221xbpn7wxls9">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="rounded-2xl border border-amber/50 bg-night-800 p-6 sm:p-8" data-id="element-358" data-mp="1scxb5zdriiby">
            <div className="flex items-center gap-4" data-id="element-359" data-mp="1sat0mylcyl2p">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-ember" data-id="element-360" data-mp="1oasl1amiw3u2">
                <GuitarIcon className="h-6 w-6 text-cream" aria-hidden="true" data-id="element-361" data-mp="2kv199jo94is5" />
              </span>
              <div data-id="element-362" data-mp="2g16t2q7uulxt">
                <p className="text-[11px] font-semibold uppercase tracking-label text-ember-light" data-id="element-363" data-mp="2g0nar8ealvj9">
                  Część druga
                </p>
                <h3 className="font-display text-3xl leading-none text-cream" data-id="element-364" data-mp="7if0ld4skn4i">Praktyka</h3>
              </div>
            </div>
            <ul className="mt-7 space-y-4" data-id="element-365" data-mp="bj8nq4aetxwc">
              {practice.map((item, index) => <li key={item} className="flex items-start gap-3" data-id="element-366" data-mp="gkobi43z2iif" data-mpi={index}>
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-amber" aria-hidden="true" data-id="element-367" data-mp="ljhjxi4ejjbq" />
                  <span className={`text-sm leading-relaxed sm:text-base ${index === 0 ? 'font-semibold text-amber-light' : 'text-cream-soft'}`} data-id="element-368" data-mp="qhj3031tvin7">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}